import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {GlobalState} from '~/types/bussiness/global'
import {req} from '~/utils/request'

const initialState: GlobalState = {
  globalConfig: {
    OSType: 'web',
    theme: 'dark',
  },
}

export const getImgGenid = createAsyncThunk<any, any>(
  'getImgGenid',
  async (arg) => {
    return req({
      url: '/api/upload/genid',
      params: {...arg},
    })
  }
)

export const getFileGenid = createAsyncThunk<any, any>(
  'getFileGenid',
  async (arg) => {
    return req({
      url: '/api/upload/genid',
      params: {...arg},
    })
  }
)

export const getInviteLanding = createAsyncThunk<any, any>(
  'getInviteLanding',
  async (arg) => {
    return req({
      url: '/api/quota/invite_landing',
      params: {...arg},
    })
  }
)

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setGlobalConfigKey: (state, action) => {
      return {
        ...state,
        globalConfig: {
          ...state.globalConfig,
          [action.payload.key]: action.payload.value,
        },
      }
    },
  },
})
export default globalSlice.reducer
export const {setGlobalConfigKey} = globalSlice.actions
